import { useApi } from './api';
import { URLS } from '../constants/urls';

export function useResultadoTesteService() {
    const { authenticatedFetch } = useApi();

    const criarResultado = async (dados) => {
        const response = await authenticatedFetch(URLS.CREATE_RESULTADO_TESTE, {
            method: 'POST',
            body: JSON.stringify(dados),
        });
        return response.json();
    };

    const obterResultadoPorId = async (id) => {
        const response = await authenticatedFetch(URLS.READ_RESULTADO_TESTE, {
            method: 'POST',
            body: JSON.stringify({ id }),
        });
        return response.json();
    };

    const listarTodosResultados = async () => {
        const response = await authenticatedFetch(URLS.READ_ALL_RESULTADO_TESTE);
        return response.json();
    };

    const listarResultadosPorParticipante = async (idParticipante, credenciais) => {
        const response = await authenticatedFetch(URLS.READ_BY_PARTICIPANTE_RESULTADO_TESTE, {
            method: 'POST',
            body: JSON.stringify({ idParticipante, ...credenciais }),
        });
        return response.json();
    };

    const deletarResultado = async (id) => {
        const response = await authenticatedFetch(URLS.DELETE_RESULTADO_TESTE, {
            method: 'POST',
            body: JSON.stringify({ id }),
        });
        return response.json();
    };

    const verificarExistenciaResultado = async ({ idTurma, idTeste, idParticipante }) => {
        const response = await authenticatedFetch(URLS.EXISTS_RESULTADO_TESTE, {
            method: 'POST',
            body: JSON.stringify({ idTurma, idTeste, idParticipante }),
        });
        return response.json();
    };

    const readResult = async (idResultado) => {
        const payload = { idResultado: idResultado?.id ?? idResultado };
        try {
            const response = await authenticatedFetch(URLS.READ_RESULT, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload),
            });
            const data = await response.json();

            console.log('[useResultadoTesteService.readResult] payload:', payload, 'resp:', data);

            return data;
        } catch (err) {
            console.error('[useResultadoTesteService.readResult] erro:', err);
            return { success: false, message: 'Falha na chamada readResult' };
        }
    };

    const obtemResultadoQuatroElementos = async (id) => {
        const response = await authenticatedFetch(URLS.GET_RESULTADO_QUATRO_ELEMENTOS, {
            method: 'POST',
            body: JSON.stringify({ id }),
        });

        return response.json();
    };

    const obtemResultadoMapaCerebral = async (id) => {
        const response = await authenticatedFetch(URLS.GET_RESULTADO_MAPA_CEREBRAL, {
            method: 'POST',
            body: JSON.stringify({ id }),
        });

        return response.json();
    };

    const gerarPdfDevolutiva = async (resultado) => {
        // pega id “cru”
        let id = resultado?.id ?? resultado;

        // se vier array (ex.: [123] ou ["abCDe"])
        if (Array.isArray(id)) id = id[0];

        // se vier objeto (ex.: { id: "..." })
        if (id && typeof id === 'object') id = id.id ?? id.value ?? null;

        const payload = { idResultado: id };

        try {
            const response = await authenticatedFetch(URLS.GERAR_PDF_DEVOLUTIVA, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload),
            });

            const data = await response.json();

            console.log('[gerarPdfDevolutiva] payload:', payload, 'resp:', data);
            return data;
        } catch (err) {
            console.error('[gerarPdfDevolutiva] erro:', err);
            return { success: false, message: 'Falha na geração do PDF de devolutiva' };
        }
    };

    const getLastResult = async (idParticipanteOrObj, idTurmaParam) => {
        // Aceita:
        // 1) getLastResult(usuario.id, idTurma)
        // 2) getLastResult({ idParticipante: usuario.id, idTurma })
        const idParticipante =
            (idParticipanteOrObj && typeof idParticipanteOrObj === 'object')
            ? (idParticipanteOrObj.idParticipante ?? idParticipanteOrObj.participanteId ?? idParticipanteOrObj.id)
            : idParticipanteOrObj;

        const idTurma =
            (idParticipanteOrObj && typeof idParticipanteOrObj === 'object')
            ? (idParticipanteOrObj.idTurma ?? idParticipanteOrObj.turmaId)
            : idTurmaParam;

        const payload = { idParticipante, idTurma };

        try {
            console.log('[useResultadoTesteService.getLastResult] payload:', payload);

            const response = await authenticatedFetch(URLS.GET_LAST_RESULT, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload),
            });

            const data = await response.json();

            console.log('[useResultadoTesteService.getLastResult] resp:', data);

            return data;
        } catch (err) {
            console.error('[useResultadoTesteService.getLastResult] erro:', err);
            return { success: false, message: 'Falha na chamada getLastResult' };
        }
    };

    return {
        criarResultado,
        obterResultadoPorId,
        listarTodosResultados,
        listarResultadosPorParticipante,
        deletarResultado,
        verificarExistenciaResultado,
        readResult,
        obtemResultadoQuatroElementos,
        obtemResultadoMapaCerebral,
        gerarPdfDevolutiva,
        getLastResult
    };
}